var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 48,
    viewBox: "0 0 58 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H50C54.4183 0 58 3.58172 58 8V40C58 44.4183 54.4183 48 50 48H8C3.58172 48 0 44.4183 0 40V8Z",
    fill: "#F7CE4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 20C26.7909 20 25 21.7909 25 24C25 26.2091 26.7909 28 29 28C31.2091 28 33 26.2091 33 24C33 21.7909 31.2091 20 29 20Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22C16.8954 22 16 22.8954 16 24C16 25.1046 16.8954 26 18 26C19.1046 26 20 25.1046 20 24C20 22.8954 19.1046 22 18 22Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22C38.8954 22 38 22.8954 38 24C38 25.1046 38.8954 26 40 26C41.1046 26 42 25.1046 42 24C42 22.8954 41.1046 22 40 22Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 11C27.8954 11 27 11.8954 27 13C27 14.1046 27.8954 15 29 15C30.1046 15 31 14.1046 31 13C31 11.8954 30.1046 11 29 11Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33C27.8954 33 27 33.8954 27 35C27 36.1046 27.8954 37 29 37C30.1046 37 31 36.1046 31 35C31 33.8954 30.1046 33 29 33Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.1671966c707124339f63b342393647f7.svg";
export { ForwardRef as ReactComponent };